import { CacheService, HttpExtra } from '@absg/angular-common';
import { CachedRequestList1 } from '@absg/api-formulary/model/cachedRequestList1'; /// need to change it to station once pai will be released.
import {
  RuleApi as StationSettingApi, RuleLite,
} from '@absg/api-station-management';
import { BaseStateManagementService, CachedRuleResult, CacheKeys, EnvironmentService } from '@absg/nim-client-shared';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StationManagementService extends BaseStateManagementService implements OnDestroy {
  constructor(
    cacheService: CacheService,
    private environmentService: EnvironmentService,
    private stationRuleApi: StationSettingApi,
  ) {
    super(cacheService);
  }

  private getXrefsByContainersByIds(containerIds: number[], extraHttpOptions?: HttpExtra): Observable<RuleLite[]> {
    const cacheTime = this.getCacheTime(CacheKeys.stationRuleContainerSettings);
    const request = {
      data: containerIds,
      clientCacheDateTime: cacheTime,
    } as CachedRequestList1;

    return this.stationRuleApi.getXrefsByContainersCached(request, extraHttpOptions).pipe(
      catchError((response: HttpErrorResponse) => {
        this.handleErrorResponse(response);
        return of({ clientCacheDateTime: cacheTime, useCache: true, data: [] } as CachedRuleResult); // return cache when erroring - example: no internet
      }),
      map((results) => this.handleCachingServiceCall(CacheKeys.stationRuleContainerSettings, results)),
      map((results) => results?.data as RuleLite[]),
    );
  }

  removeProductCacheTimeKey(): void {
    this.removeCacheTime(CacheKeys.stationRuleContainerSettings, true);
  }

  getXrefsByContainers(containerIds: number[]): Observable<RuleLite[]> {
    if (this.environmentService.usingStateManagement()) {
      return this.getXrefsByContainersByIds(containerIds);
    } else {
      return this.stationRuleApi.getXrefsByContainers(containerIds);
    }
  }
}
